export default {
  list: [
    {
      title: 'همه کاربرها',
      value: 'ALL_USERS',
    },
    {
      title: 'افرادی که برای اولین بار وارد اپلیکیشن می شوند',
      value: 'AFTER_LOGIN_TO_APP_FOR_FIRST_TIME',
    },
    {
      title: 'کاربرهای خاص',
      value: 'SPECIAL_USERS',
    },
    {
      title: 'افرادی با حداقل رزرو موفق',
      value: 'HAS_MIN_SUCCESSFUL_RESERVATION',
    },
    {
      title: 'افرادی با حداقل سفارش در رزروهای خود',
      value: 'HAS_MIN_ORDER_IN_RESERVATION',
    },
  ],
  values: {
    ALL_USERS: 'ALL_USERS',
    AFTER_LOGIN_TO_APP_FOR_FIRST_TIME: 'AFTER_LOGIN_TO_APP_FOR_FIRST_TIME',
    HAS_MIN_SUCCESSFUL_RESERVATION: 'HAS_MIN_SUCCESSFUL_RESERVATION',
    HAS_MIN_ORDER_IN_RESERVATION: 'HAS_MIN_ORDER_IN_RESERVATION',
    SPECIAL_USERS: 'SPECIAL_USERS',
  },
};
